import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import useTutorialStatus from '../../hooks/useTutorialStatus';
import NewFeatureAnnouncementModal from '../NewFeatureAnnouncementModal';
import { usePriorityPopupBlocking } from '../consent/priorityPopupStore';

const INITIAL_ONBOARDING_KEY = 'rvincente_onboarding_v1_seen';
const LATER_COUNT_KEY = 'my_selection_popup_later_count';
const MAX_LATER = 3;
const SAME_SESSION_DELAY_MS = 3000;

const readFlag = () => { try { return !!localStorage.getItem(INITIAL_ONBOARDING_KEY); } catch { return true; } };
const readLater = () => { try { return parseInt(localStorage.getItem(LATER_COUNT_KEY) || '0', 10) || 0; } catch { return 0; } };

// "Nuova funzione" popup on app open until the "La mia selezione" tour is completed ("Più tardi" max 3 times).
// Never stacks with the welcome tutorial or priority popups; the AI Schedina announcement waits for this tour.
// If the welcome tutorial is completed in this session, it appears on Home 3s after the screen is free.
export default function MySelectionAnnouncementGate() {
  const { loading: authLoading } = useAuth();
  const { seen, loading } = useTutorialStatus('my_selection');
  const blocking = usePriorityPopupBlocking();
  const [dismissed, setDismissed] = useState(false);
  const [laterCount] = useState(readLater);
  const [onboardingAtMount] = useState(readFlag);
  const [onboardingDone, setOnboardingDone] = useState(onboardingAtMount);
  const [delayOk, setDelayOk] = useState(onboardingAtMount);
  const navigate = useNavigate();
  const location = useLocation();
  // Wait until no other full-screen modal is open (e.g. web "scarica l'app", welcome tutorial).
  const [screenFree, setScreenFree] = useState(false);
  useEffect(() => {
    const check = () => {
      setScreenFree(!document.querySelector('.fixed.inset-0:not([data-testid="my-selection-feature-modal"])'));
      if (!onboardingAtMount && readFlag()) setOnboardingDone(true);
    };
    const t = setInterval(check, 1000);
    check();
    return () => clearInterval(t);
  }, [onboardingAtMount]);

  const onHome = location.pathname === '/dashboard';
  const sameSessionReady = !onboardingAtMount && onboardingDone && onHome && screenFree && !blocking;
  useEffect(() => {
    if (onboardingAtMount || delayOk || !sameSessionReady) return undefined;
    const t = setTimeout(() => setDelayOk(true), SAME_SESSION_DELAY_MS);
    return () => clearTimeout(t);
  }, [onboardingAtMount, delayOk, sameSessionReady]);

  if (authLoading || loading || seen || dismissed || blocking || !onboardingDone || !screenFree || !delayOk) return null;
  if (laterCount >= MAX_LATER) return null;
  if (/tour=/.test(location.search)) return null;
  if (location.pathname.startsWith('/login') || location.pathname.startsWith('/admin')) return null;
  if (!onboardingAtMount && !onHome) return null;

  const tryNow = () => {
    setDismissed(true);
    if (location.pathname === '/dashboard') window.dispatchEvent(new Event('startMySelectionTour'));
    else navigate('/dashboard?tour=my_selection');
  };
  const later = () => {
    setDismissed(true);
    try { localStorage.setItem(LATER_COUNT_KEY, String(laterCount + 1)); } catch { /* ignore */ }
  };

  return (
    <NewFeatureAnnouncementModal
      testId="my-selection-feature-modal"
      title={<>Segui live<br />la tua selezione</>}
      description="Carica lo screenshot della tua selezione: riconosciamo gli eventi e li coloriamo in tempo reale, con un avviso a ogni gol."
      onTryNow={tryNow}
      onLater={later}
    />
  );
}
